import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import ChatBar from "./components/ChatBar";
import ChatContainer from "./ChatContainer";
import { fetchInitialConfig, initExternalListener, showChatPanel } from "./features/ChatBarActions";
import { withChatContext } from "./Context";
class ChatBarContainer extends Component {
  constructor(props) {
    super(props);
    this.onChatBarClick = this.onChatBarClick.bind(this);
  }
  componentDidMount() {
    this.props.initExternalListener();
    this.props.fetchInitialConfig();
  }
  onChatBarClick() {
    this.props.showChatPanel();
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "chat"
    }, /*#__PURE__*/React.createElement(ChatBar, {
      show: this.props.config.showChatBar,
      name: this.props.config.consumerName,
      onClick: this.onChatBarClick,
      businessUnit: this.props.config.businessUnit,
      used: this.props.config.hasBeenUsed
    }), /*#__PURE__*/React.createElement(ChatContainer, {
      show: this.props.config.showChatPanel,
      businessUnit: this.props.config.businessUnit
    }));
  }
}
ChatBarContainer.propTypes = {
  initExternalListener: PropTypes.func,
  fetchInitialConfig: PropTypes.func,
  showChatPanel: PropTypes.func,
  config: PropTypes.object
};
const mapStateToProps = (state, ownProps) => ({
  config: state.chat.config
});
const mapDispatchToProps = (dispatch, {
  apiClient
}) => ({
  initExternalListener: () => dispatch(initExternalListener()),
  fetchInitialConfig: () => dispatch(fetchInitialConfig(apiClient)),
  showChatPanel: () => dispatch(showChatPanel(apiClient))
});
export default compose(withChatContext, connect(mapStateToProps, mapDispatchToProps))(ChatBarContainer);